import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDrop } from "react-dnd";
import { CanvasContext } from "../../../contexts/CanvasContext";
import ButtonComponent from "./ButtonComponent";
import ImageComponent from "./ImageComponent";
import HeaderComponent from "./HeaderComponent";
import ParagraphComponent from "./ParagraphComponent";
import IconComponent from "./IconComponent";
import LinkComponent from "./LinkComponent";
import CheckboxComponent from "./CheckboxComponent";
import RadioComponent from "./RadioComponent";
import ListComponent from "./ListComponent";
import TableComponent from "./TableComponent";
import VideoComponent from "./VideoComponent";
import TextInputComponent from "./TextComponent";
import RangeComponent from "./RangeComponent";
import PasswordInputComponent from "./PasswordInputComponent";
import EmailInputComponent from "./EmailInputComponent";
import NumberInputComponent from "./NumberInputComponent";
import DateInputComponent from "./DateInputComponent";
import ColorInputComponent from "./ColorInputComponent";
import FileInputComponent from "./FileInputComponent";
import AudioComponent from "./AudioComponent";
import DropDownComponent from "./DropDownComponent";
import MapComponent from "./MapComponent";
import Division from "./Division";
import Nav from "./Nav";
import HeaderTag from "./HeaderTag";
import Hgroup from "./Hgroup";
import Span from "./Span";
import FormComponent from "./FormComponent";
import MainComponent from "./MainComponent";
import ArticleComponent from "./ArticleComponent";
import AsideComponent from "./AsideComponent";
import HRTag from "./HRTag";
import BRTag from "./BRTag";
import OutputComponent from "./OutputComponent";
import IframeComponent from "./IframeComponent";
import Section from "./Section";

const Footer = ({ footer }) => {
  const footerRef = useRef(null);

  const { addElement, hoveredDivision, files, addCanvasDrop, addDivision } =
    useContext(CanvasContext);
  const isHovered = footer.id === hoveredDivision;
  const [isFooterHovered, setIsFooterHovered] = useState(false);
  const [isFooterFocused, setIsFooterFocused] = useState(false);
  const [isFooterActive, setIsFooterActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = footer;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = footer;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = footer;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = footer;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const generateKeyframes = () => {
    if (!footer.keyframes || footer.keyframes.length === 0) return null;

    return footer.keyframes.map((kf) => {
      const properties = {};
      let transform = "";

      Object.entries(kf.properties).forEach(([key, value]) => {
        // Remove 'KEY' prefix if present
        let processedKey = key.startsWith("KEY") ? key.slice(3) : key;

        // Handle transform properties
        if (
          processedKey === "scale" ||
          processedKey === "translateX" ||
          processedKey === "translateY" ||
          processedKey === "rotate" ||
          processedKey === "skewX" ||
          processedKey === "skewY"
        ) {
          if (value) {
            switch (processedKey) {
              case "scale":
                transform += `scale(${value}) `;
                break;
              case "translateX":
                transform += `translateX(${value}) `;
                break;
              case "translateY":
                transform += `translateY(${value}) `;
                break;
              case "rotate":
                transform += `rotate(${value}) `;
                break;
              case "skewX":
                transform += `skewX(${value}) `;
                break;
              case "skewY":
                transform += `skewY(${value}) `;
                break;
              default:
                break;
            }
          }
        } else {
          // Convert camelCase to kebab-case for other CSS properties
          properties[processedKey] = value;
        }
      });

      // Add transform property if it was built
      if (transform) {
        properties["transform"] = transform.trim();
      }

      return {
        offset: kf.position / 100,
        ...properties,
      };
    });
  };

  useEffect(() => {
    if (footerRef.current && footer.keyframes && footer.keyframes.length > 0) {
      const keyframes = generateKeyframes();
      const animation = footerRef.current.animate(keyframes, {
        duration: parseFloat(footer.animationDuration) * 1000 || 1000,
        delay: parseFloat(footer.animationDelay) * 1000 || 0,
        iterations:
          footer.animationIterationCount === "infinite"
            ? Infinity
            : parseFloat(footer.animationIterationCount) || 1,
        direction: footer.animationDirection || "normal",
        fill: footer.animationFillMode || "none",
        easing: footer.animationTimingFunction || "linear",
      });

      return () => animation.cancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    footer.keyframes,
    footer.animationDuration,
    footer.animationDelay,
    footer.animationIterationCount,
    footer.animationDirection,
    footer.animationFillMode,
    footer.animationTimingFunction,
  ]);

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (footer.backgroundImage && footer.backgroundImage.startsWith("./")) {
        const imageName = footer.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(footer.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [footer.backgroundImage, files]);

  const focusedStyles =
    isFooterFocused && footer.pseudoClass === "focus"
      ? {
          width: footer.focusedwidth || footer.width || "100%",
          height: footer.focusedheight || footer.height || "auto",

          padding: footer.focusedpadding || footer.padding || "8px",
          paddingTop:
            footer.focusedpaddingTop || footer.focusedpadding || "8px",
          paddingRight:
            footer.focusedpaddingRight || footer.focusedpadding || "8px",
          paddingBottom:
            footer.focusedpaddingBottom || footer.focusedpadding || "8px",
          paddingLeft:
            footer.focusedpaddingLeft || footer.focusedpadding || "8px",
          margin: footer.focusedmargin || footer.margin || "0px",
          marginTop: footer.focusedmarginTop || footer.focusedmargin || "0px",
          marginRight:
            footer.focusedmarginRight || footer.focusedmargin || "0px",
          marginBottom:
            footer.focusedmarginBottom || footer.focusedmargin || "0px",
          marginLeft: footer.focusedmarginLeft || footer.focusedmargin || "0px",

          borderTop:
            footer.focusedborderTop ||
            footer.focusedborder ||
            footer.border ||
            "1px solid black",
          borderRight:
            footer.focusedborderRight ||
            footer.focusedborder ||
            footer.border ||
            "1px solid black",
          borderBottom:
            footer.focusedborderBottom ||
            footer.focusedborder ||
            footer.border ||
            "1px solid black",
          borderLeft:
            footer.focusedborderLeft ||
            footer.focusedborder ||
            footer.border ||
            "1px solid black",
          borderSapcing:
            footer.focusedborderSpacing || footer.borderSpacing || "0px",
          borderCollapse:
            footer.focusedborderCollapse || footer.borderCollapse || "0px",
          borderRadius:
            footer.focusedborderRadius || footer.borderRadius || "0",
          outline: footer.focusedoutline || footer.outline || "none",

          position: footer.focusedposition || footer.position || "relative",
          top: footer.focusedtop || footer.top || "auto",
          right: footer.focusedright || footer.right || "auto",
          bottom: footer.focusedbottom || footer.bottom || "auto",
          left: footer.focusedleft || footer.left || "auto",
          zIndex: footer.focusedzIndex || footer.zIndex || "auto",
          boxShadow: footer.focusedboxShadow || footer.boxShadow || "none",
          opacity: footer.focusedOpacity || footer.opacity || 1,
          display: footer.focuseddisplay || footer.display || "block",
          flexDirection:
            footer.focusedflexDirection || footer.flexDirection || "column",
          flexWrap: footer.focusedflexWrap || "nowrap",
          order: footer.focusedorder || "0",
          flexGrow: footer.focusedflexGrow || "0",
          flexShrink: footer.focusedflexShrink || "1",
          flexBasis: footer.focusedflexBasis || "auto",

          gridTemplateColumns: footer.focusedgridTemplateColumns || "none",
          gridTemplateRows: footer.focusedgridTemplateRows || "none",
          gridArea: footer.focusedgridArea || "auto",
          gridAutoFlow: footer.focusedgridAutoFlow || "row",
          gridAutoColumns: footer.focusedgridAutoColumns || "auto",
          gridAutoRows: footer.focusedgridAutoRows || "auto",
          columnGap: footer.focusedcolumnGap || "0",
          rowGap: footer.focusedrowGap || "0",

          justifyContent: footer.focusedjustifyContent || "flex-start",
          alignItems: footer.focusedalignItems || "stretch",
          alignContent: footer.focusedalignContent || "stretch",
          alignSelf: footer.focusedalignSelf || "auto",
          // placeContent: footer.focusedplaceContent || "normal",
          // placeItems: footer.focusedplaceItems || "normal",
          justifyItems: footer.focusedjustifyItems || "stretch",
          justifySelf: footer.focusedjustifySelf || "auto",

          gap: footer.focusedgap || "0",
          visibility: footer.focusedvisibility || "visible",

          color: footer.focusedcolor || footer.color || "#000000",
          backgroundColor:
            footer.focusedbackgroundColor ||
            footer.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (footer.focusedbackgroundImage) {
              if (footer.focusedbackgroundImage.startsWith("./")) {
                const imageName = footer.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${footer.focusedbackgroundImage})`;
            }
            if (footer.backgroundImage) {
              if (footer.backgroundImage.startsWith("./")) {
                const imageName = footer.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${footer.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            footer.focusedbackgroundPosition ||
            footer.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            footer.focusedbackgroundSize || footer.backgroundSize || "auto",
          backgroundRepeat:
            footer.focusedbackgroundRepeat ||
            footer.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            footer.focusedbackgroundAttachment ||
            footer.backgroundAttachment ||
            "scroll",

          fontFamily:
            footer.focusedfontFamily || footer.fontFamily || "inherit",
          fontSize: footer.focusedfontSize || footer.fontSize || "inherit",
          fontWeight: footer.focusedfontWeight || footer.fontWeight || "normal",
          fontStyle: footer.focusedfontStyle || footer.fontStyle || "normal",
          fontVariant:
            footer.focusedfontVariant || footer.fontVariant || "normal",
          lineHeight: footer.focusedlineHeight || footer.lineHeight || "normal",
          textShadow: footer.focusedtextShadow || footer.textShadow || "none",
          textAlign: footer.focusedtextAlign || footer.textAlign || "left",
          verticalAlign:
            footer.focusedverticalAlign || footer.verticalAlign || "baseline",
          textDecoration:
            footer.focusedtextDecoration || footer.textDecoration || "none",
          textTransform:
            footer.focusedtextTransform || footer.textTransform || "none",
          letterSpacing:
            footer.focusedletterSpacing || footer.letterSpacing || "normal",
          wordSpacing:
            footer.focusedwordSpacing || footer.wordSpacing || "normal",
          textIndent: footer.focusedtextIndent || footer.textIndent || "0",
          whiteSpace: footer.focusedwhiteSpace || footer.whiteSpace || "normal",
          textOverflow:
            footer.focusedtextOverflow || footer.textOverflow || "clip",
          direction: footer.focuseddirection || footer.direction || "ltr",
          unicodeBidi:
            footer.focusedunicodeBidi || footer.unicodeBidi || "normal",
          writingMode:
            footer.focusedwritingMode || footer.writingMode || "horizontal-tb",

          cursor: footer.focusedcursor || footer.cursor || "default",
          filter: footer.focusedfilter || footer.filter || "none",
          backdropFilter:
            footer.focusedbackdropFilter || footer.backdropFilter || "none",
          mixBlendMode:
            footer.focusedmixBlendMode || footer.mixBlendMode || "normal",
          aspectRatio:
            footer.focusedaspectRatio || footer.aspectRatio || "auto",

          transform: footer.focusedtransform || footer.transform || "none",
          transition: footer.focusedtransition || footer.transition || "none",
        }
      : {};

  const hoverStyles =
    isFooterHovered && footer.pseudoClass === "hover"
      ? {
          width: footer.hoveredwidth || footer.width || "100%",
          height: footer.hoveredheight || footer.height || "auto",

          padding: footer.hoveredpadding || footer.padding || "8px",
          paddingTop:
            footer.hoveredpaddingTop || footer.hoveredpadding || "8px",
          paddingRight:
            footer.hoveredpaddingRight || footer.hoveredpadding || "8px",
          paddingBottom:
            footer.hoveredpaddingBottom || footer.hoveredpadding || "8px",
          paddingLeft:
            footer.hoveredpaddingLeft || footer.hoveredpadding || "8px",
          margin: footer.hoveredmargin || footer.margin || "0px",
          marginTop: footer.hoveredmarginTop || footer.hoveredmargin || "0px",
          marginRight:
            footer.hoveredmarginRight || footer.hoveredmargin || "0px",
          marginBottom:
            footer.hoveredmarginBottom || footer.hoveredmargin || "0px",
          marginLeft: footer.hoveredmarginLeft || footer.hoveredmargin || "0px",

          borderTop:
            footer.hoveredborderTop ||
            footer.hoveredborder ||
            footer.border ||
            "1px solid black",
          borderRight:
            footer.hoveredborderRight ||
            footer.hoveredborder ||
            footer.border ||
            "1px solid black",
          borderBottom:
            footer.hoveredborderBottom ||
            footer.hoveredborder ||
            footer.border ||
            "1px solid black",
          borderLeft:
            footer.hoveredborderLeft ||
            footer.hoveredborder ||
            footer.border ||
            "1px solid black",
          borderSapcing:
            footer.hoveredborderSpacing || footer.borderSpacing || "0px",
          borderCollapse:
            footer.hoveredborderCollapse || footer.borderCollapse || "0px",
          borderRadius:
            footer.hoveredborderRadius || footer.borderRadius || "0",
          outline: footer.hoveredoutline || footer.outline || "none",

          position: footer.hoveredposition || footer.position || "relative",
          top: footer.hoveredtop || footer.top || "auto",
          right: footer.hoveredright || footer.right || "auto",
          bottom: footer.hoveredbottom || footer.bottom || "auto",
          left: footer.hoveredleft || footer.left || "auto",
          zIndex: footer.hoveredzIndex || footer.zIndex || "auto",
          boxShadow: footer.hoveredboxShadow || footer.boxShadow || "none",
          opacity: footer.hoveredOpacity || footer.opacity || 1,
          display: footer.hovereddisplay || footer.display || "block",
          flexDirection:
            footer.hoveredflexDirection || footer.flexDirection || "column",
          flexWrap: footer.hoveredflexWrap || "nowrap",
          order: footer.hoveredorder || "0",
          flexGrow: footer.hoveredflexGrow || "0",
          flexShrink: footer.hoveredflexShrink || "1",
          flexBasis: footer.hoveredflexBasis || "auto",

          gridTemplateColumns: footer.hoveredgridTemplateColumns || "none",
          gridTemplateRows: footer.hoveredgridTemplateRows || "none",
          gridArea: footer.hoveredgridArea || "auto",
          gridAutoFlow: footer.hoveredgridAutoFlow || "row",
          gridAutoColumns: footer.hoveredgridAutoColumns || "auto",
          gridAutoRows: footer.hoveredgridAutoRows || "auto",
          columnGap: footer.hoveredcolumnGap || "0",
          rowGap: footer.hoveredrowGap || "0",

          justifyContent: footer.hoveredjustifyContent || "flex-start",
          alignItems: footer.hoveredalignItems || "stretch",
          alignContent: footer.hoveredalignContent || "stretch",
          alignSelf: footer.hoveredalignSelf || "auto",
          // placeContent: footer.hoveredplaceContent || "normal",
          // placeItems: footer.hoveredplaceItems || "normal",
          justifyItems: footer.hoveredjustifyItems || "stretch",
          justifySelf: footer.hoveredjustifySelf || "auto",

          gap: footer.hoveredgap || "0",
          visibility: footer.hoveredvisibility || "visible",

          color: footer.hoveredcolor || footer.color || "#000000",
          backgroundColor:
            footer.hoveredbackgroundColor ||
            footer.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (footer.hoveredbackgroundImage) {
              if (footer.hoveredbackgroundImage.startsWith("./")) {
                const imageName = footer.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${footer.hoveredbackgroundImage})`;
            }
            if (footer.backgroundImage) {
              if (footer.backgroundImage.startsWith("./")) {
                const imageName = footer.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${footer.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            footer.hoveredbackgroundPosition ||
            footer.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            footer.hoveredbackgroundSize || footer.backgroundSize || "auto",
          backgroundRepeat:
            footer.hoveredbackgroundRepeat ||
            footer.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            footer.hoveredbackgroundAttachment ||
            footer.backgroundAttachment ||
            "scroll",

          fontFamily:
            footer.hoveredfontFamily || footer.fontFamily || "inherit",
          fontSize: footer.hoveredfontSize || footer.fontSize || "inherit",
          fontWeight: footer.hoveredfontWeight || footer.fontWeight || "normal",
          fontStyle: footer.hoveredfontStyle || footer.fontStyle || "normal",
          fontVariant:
            footer.hoveredfontVariant || footer.fontVariant || "normal",
          lineHeight: footer.hoveredlineHeight || footer.lineHeight || "normal",
          textShadow: footer.hoveredtextShadow || footer.textShadow || "none",
          textAlign: footer.hoveredtextAlign || footer.textAlign || "left",
          verticalAlign:
            footer.hoveredverticalAlign || footer.verticalAlign || "baseline",
          textDecoration:
            footer.hoveredtextDecoration || footer.textDecoration || "none",
          textTransform:
            footer.hoveredtextTransform || footer.textTransform || "none",
          letterSpacing:
            footer.hoveredletterSpacing || footer.letterSpacing || "normal",
          wordSpacing:
            footer.hoveredwordSpacing || footer.wordSpacing || "normal",
          textIndent: footer.hoveredtextIndent || footer.textIndent || "0",
          whiteSpace: footer.hoveredwhiteSpace || footer.whiteSpace || "normal",
          textOverflow:
            footer.hoveredtextOverflow || footer.textOverflow || "clip",
          direction: footer.hovereddirection || footer.direction || "ltr",
          unicodeBidi:
            footer.hoveredunicodeBidi || footer.unicodeBidi || "normal",
          writingMode:
            footer.hoveredwritingMode || footer.writingMode || "horizontal-tb",

          cursor: footer.hoveredcursor || footer.cursor || "default",
          filter: footer.hoveredfilter || footer.filter || "none",
          backdropFilter:
            footer.hoveredbackdropFilter || footer.backdropFilter || "none",
          mixBlendMode:
            footer.hoveredmixBlendMode || footer.mixBlendMode || "normal",
          aspectRatio:
            footer.hoveredaspectRatio || footer.aspectRatio || "auto",

          transform: footer.hoveredtransform || footer.transform || "none",
          transition: footer.hoveredtransition || footer.transition || "none",
        }
      : {};

  const activeStyles =
    isFooterActive && footer.pseudoClass === "active"
      ? {
          width: footer.activatedwidth || footer.width || "100%",
          height: footer.hoveredheight || footer.height || "auto",

          padding: footer.activatedpadding || footer.padding || "8px",
          paddingTop:
            footer.activatedpaddingTop || footer.activatedpadding || "8px",
          paddingRight:
            footer.activatedpaddingRight || footer.activatedpadding || "8px",
          paddingBottom:
            footer.activatedpaddingBottom || footer.activatedpadding || "8px",
          paddingLeft:
            footer.activatedpaddingLeft || footer.activatedpadding || "8px",
          margin: footer.activatedmargin || footer.margin || "0px",
          marginTop:
            footer.activatedmarginTop || footer.activatedmargin || "0px",
          marginRight:
            footer.activatedmarginRight || footer.activatedmargin || "0px",
          marginBottom:
            footer.activatedmarginBottom || footer.activatedmargin || "0px",
          marginLeft:
            footer.activatedmarginLeft || footer.activatedmargin || "0px",

          borderTop:
            footer.activatedborderTop ||
            footer.activatedborder ||
            footer.border ||
            "1px solid black",
          borderRight:
            footer.activatedborderRight ||
            footer.activatedborder ||
            footer.border ||
            "1px solid black",
          borderBottom:
            footer.activatedborderBottom ||
            footer.activatedborder ||
            footer.border ||
            "1px solid black",
          borderLeft:
            footer.activatedborderLeft ||
            footer.activatedborder ||
            footer.border ||
            "1px solid black",
          borderSapcing:
            footer.activatedborderSpacing || footer.borderSpacing || "0px",
          borderCollapse:
            footer.activatedborderCollapse || footer.borderCollapse || "0px",
          borderRadius:
            footer.activatedborderRadius || footer.borderRadius || "0",
          outline: footer.activatedoutline || footer.outline || "none",

          position: footer.activatedposition || footer.position || "relative",
          top: footer.activatedtop || footer.top || "auto",
          right: footer.activatedright || footer.right || "auto",
          bottom: footer.activatedbottom || footer.bottom || "auto",
          left: footer.activatedleft || footer.left || "auto",
          zIndex: footer.activatedzIndex || footer.zIndex || "auto",

          boxShadow: footer.activatedboxShadow || footer.boxShadow || "none",
          opacity: footer.activatedOpacity || footer.opacity || 1,
          display: footer.activateddisplay || footer.display || "block",
          flexDirection:
            footer.activatedflexDirection || footer.flexDirection || "column",
          flexWrap: footer.activatedflexWrap || "nowrap",
          order: footer.activatedorder || "0",
          flexGrow: footer.activatedflexGrow || "0",
          flexShrink: footer.activatedflexShrink || "1",
          flexBasis: footer.activatedflexBasis || "auto",

          gridTemplateColumns: footer.activatedgridTemplateColumns || "none",
          gridTemplateRows: footer.activatedgridTemplateRows || "none",
          gridArea: footer.activatedgridArea || "auto",
          gridAutoFlow: footer.activatedgridAutoFlow || "row",
          gridAutoColumns: footer.activatedgridAutoColumns || "auto",
          gridAutoRows: footer.activatedgridAutoRows || "auto",
          columnGap: footer.activatedcolumnGap || "0",
          rowGap: footer.activatedrowGap || "0",

          justifyContent: footer.activatedjustifyContent || "flex-start",
          alignItems: footer.activatedalignItems || "stretch",
          alignContent: footer.activatedalignContent || "stretch",
          alignSelf: footer.activatedalignSelf || "auto",
          // placeContent: footer.activatedplaceContent || "normal",
          // placeItems: footer.activatedplaceItems || "normal",
          justifyItems: footer.activatedjustifyItems || "stretch",
          justifySelf: footer.activatedjustifySelf || "auto",

          gap: footer.activatedgap || "0",
          visibility: footer.activatedvisibility || "visible",

          color: footer.activatedcolor || footer.color || "#000000",
          backgroundColor:
            footer.activatedbackgroundColor ||
            footer.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (footer.activatedbackgroundImage) {
              if (footer.activatedbackgroundImage.startsWith("./")) {
                const imageName = footer.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${footer.activatedbackgroundImage})`;
            }
            if (footer.backgroundImage) {
              if (footer.backgroundImage.startsWith("./")) {
                const imageName = footer.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${footer.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            footer.activatedbackgroundPosition ||
            footer.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            footer.activatedbackgroundSize || footer.backgroundSize || "auto",
          backgroundRepeat:
            footer.activatedbackgroundRepeat ||
            footer.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            footer.activatedbackgroundAttachment ||
            footer.backgroundAttachment ||
            "scroll",

          fontFamily:
            footer.activatedfontFamily || footer.fontFamily || "inherit",
          fontSize: footer.activatedfontSize || footer.fontSize || "inherit",
          fontWeight:
            footer.activatedfontWeight || footer.fontWeight || "normal",
          fontStyle: footer.activatedfontStyle || footer.fontStyle || "normal",
          fontVariant:
            footer.activatedfontVariant || footer.fontVariant || "normal",
          lineHeight:
            footer.activatedlineHeight || footer.lineHeight || "normal",
          textShadow: footer.activatedtextShadow || footer.textShadow || "none",
          textAlign: footer.activatedtextAlign || footer.textAlign || "left",
          verticalAlign:
            footer.activatedverticalAlign || footer.verticalAlign || "baseline",
          textDecoration:
            footer.activatedtextDecoration || footer.textDecoration || "none",
          textTransform:
            footer.activatedtextTransform || footer.textTransform || "none",
          letterSpacing:
            footer.activatedletterSpacing || footer.letterSpacing || "normal",
          wordSpacing:
            footer.activatedwordSpacing || footer.wordSpacing || "normal",
          textIndent: footer.activatedtextIndent || footer.textIndent || "0",
          whiteSpace:
            footer.activatedwhiteSpace || footer.whiteSpace || "normal",
          textOverflow:
            footer.activatedtextOverflow || footer.textOverflow || "clip",
          direction: footer.activateddirection || footer.direction || "ltr",
          unicodeBidi:
            footer.activatedunicodeBidi || footer.unicodeBidi || "normal",
          writingMode:
            footer.activatedwritingMode ||
            footer.writingMode ||
            "horizontal-tb",

          cursor: footer.activatedcursor || footer.cursor || "default",
          filter: footer.activatedfilter || footer.filter || "none",
          backdropFilter:
            footer.activatedbackdropFilter || footer.backdropFilter || "none",
          mixBlendMode:
            footer.activatedmixBlendMode || footer.mixBlendMode || "normal",
          aspectRatio:
            footer.activatedaspectRatio || footer.aspectRatio || "auto",

          transform: footer.activatedtransform || footer.transform || "none",
          transition: footer.activatedtransition || footer.transition || "none",
        }
      : {};

  const [, drop] = useDrop({
    accept: [
      "DroppableDiv",
      "DroppableButton",
      "DroppableImage",
      "DroppableHeading",
      "DroppableParagraph",
      "DroppableIcon",
      "DroppableLink",
      "DroppableCheckbox",
      "DroppableRadio",
      "DroppableList",
      "DroppableTable",
      "DroppableVideo",
      "DroppableAudio",
      "DroppableTextInput",
      "DroppableRangeInput",
      "DroppablePasswordInput",
      "DroppableEmailInput",
      "DroppableNumberInput",
      "DroppableDateInput",
      "DroppableColorInput",
      "DroppableFileInput",
      "DroppableDropDown",
      "DroppableMap",
      "DroppableNav",
      "DroppableHeader",
      "DroppableHGroup",
      "DroppableFooter",
      "DroppableSection",
      "DroppableSpan",
      "DroppableForm",
      "DroppableMain",
      "DroppableArticle",
      "DroppableAside",
      "DroppableHorizontalRule",
      "DroppableLineBreak",
      "DroppableIframe",
    ],
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        if (item.type === "DroppableDiv") {
          addDivision(footer.id, item.name, item.type);
        } else if (
          item.type === "DroppableNav" ||
          item.type === "DroppableHeader" ||
          item.type === "DroppableHGroup" ||
          item.type === "DroppableFooter" ||
          item.type === "DroppableSection" ||
          item.type === "DroppableSpan" ||
          item.type === "DroppableForm" ||
          item.type === "DroppableMain" ||
          item.type === "DroppableArticle" ||
          item.type === "DroppableAside"
        ) {
          addCanvasDrop(footer.id, item.name, item.type);
        } else {
          addElement(footer.id, item.name, item.type);
        }
      }
    },
  });

  const footerStyle = {
    width: footer.width || "100%",
    height: footer.height || "auto",
    padding: footer.padding || "8px",
    paddingTop: footer.paddingTop || footer.padding || "8px",
    paddingRight: footer.paddingRight || footer.padding || "8px",
    paddingBottom: footer.paddingBottom || footer.padding || "8px",
    paddingLeft: footer.paddingLeft || footer.padding || "8px",
    margin: footer.margin || "0px",
    marginTop: footer.marginTop || footer.margin || "0px",
    marginRight: footer.marginRight || footer.margin || "0px",
    marginBottom: footer.marginBottom || footer.margin || "0px",
    marginLeft: footer.marginLeft || footer.margin || "0px",

    borderTop: footer.borderTop || footer.border || "1px solid #000000",
    borderRight: footer.borderRight || footer.border || "1px solid #000000",
    borderBottom: footer.borderBottom || footer.border || "1px solid #000000",
    borderLeft: footer.borderLeft || footer.border || "1px solid #000000",

    borderSapcing: footer.borderSpacing || "0px",
    borderCollapse: footer.borderCollapse || "0px",
    borderRadius: footer.borderRadius || "0",
    boxSizing: footer.boxSizing || "border-box",

    position: footer.position || "relative",
    top: footer.top || "auto",
    right: footer.right || "auto",
    bottom: footer.bottom || "auto",
    left: footer.left || "auto",
    zIndex: footer.zIndex || "auto",

    display: footer.display || "block",
    flexDirection: footer.flexDirection || "column",
    flexWrap: footer.flexWrap || "nowrap",
    order: footer.order || "0",
    flexGrow: footer.flexGrow || "0",
    flexShrink: footer.flexShrink || "1",
    flexBasis: footer.flexBasis || "auto",

    gridTemplateColumns: footer.gridTemplateColumns || "none",
    gridTemplateRows: footer.gridTemplateRows || "none",
    gridArea: footer.gridArea || "auto",
    gridAutoFlow: footer.gridAutoFlow || "row",
    gridAutoColumns: footer.gridAutoColumns || "auto",
    gridAutoRows: footer.gridAutoRows || "auto",
    columnGap: footer.columnGap || "0",
    rowGap: footer.rowGap || "0",

    justifyContent: footer.justifyContent || "flex-start",
    alignItems: footer.alignItems || "stretch",
    alignContent: footer.alignContent || "stretch",
    alignSelf: footer.alignSelf || "auto",
    // placeContent: footer.placeContent || "normal",
    // placeItems: footer.placeItems || "normal",
    justifyItems: footer.justifyItems || "stretch",
    justifySelf: footer.justifySelf || "auto",

    gap: footer.gap || "0",
    visibility: footer.visibility || "visible",

    color: footer.color || "#000000",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),

    backgroundPosition: footer.backgroundPosition || "0% 0%",
    backgroundSize: footer.backgroundSize || "auto",
    backgroundRepeat: footer.backgroundRepeat || "repeat",
    backgroundAttachment: footer.backgroundAttachment || "scroll",
    boxShadow: footer.boxShadow || "none",
    filter: footer.filter || "none",
    backdropFilter: footer.backdropFilter || "none",
    mixBlendMode: footer.mixBlendMode || "normal",
    aspectRatio: footer.aspectRatio || "auto",

    resize: footer.resize || "none",
    userSelect: footer.userSelect || "auto",
    overflow: footer.resize && footer.resize !== "none" ? "auto" : "visible",
    overflowX: footer.overflowX || "hidden",
    overflowY: footer.overflowY || "hidden",

    fontSize: footer.fontSize || "inherit",
    fontFamily: footer.fontFamily || "inherit",
    fontWeight: footer.fontWeight || "normal",
    fontStyle: footer.fontStyle || "normal",
    fontVariant: footer.fontVariant || "normal",
    lineHeight: footer.lineHeight || "normal",
    textAlign: footer.textAlign || "left",
    textDecoration: footer.textDecoration || "none",
    textTransform: footer.textTransform || "none",
    textShadow: footer.textShadow || "none",
    verticalAlign: footer.verticalAlign || "baseline",
    letterSpacing: footer.letterSpacing || "normal",
    wordSpacing: footer.wordSpacing || "normal",
    textIndent: footer.textIndent || "0",
    whiteSpace: footer.whiteSpace || "normal",
    textOverflow: footer.textOverflow || "clip",
    direction: footer.direction || "ltr",
    unicodeBidi: footer.unicodeBidi || "normal",
    writingMode: footer.writingMode || "horizontal-tb",
    cursor: footer.cursor || "default",
    outline: footer.outline || "none",

    backgroundColor: isHovered
      ? "#ADD8E6"
      : footer.backgroundColor || "#ffffff",

    listStyleType: footer.listStyleType || "disc",
    listStyleImage: footer.listStyleImage
      ? `url(${footer.listStyleImage})`
      : "none",
    listStylePosition: footer.listStylePosition || "outside",

    transform: footer.transform || "none",
    transition:
      footer.transition || "transform 0.3s ease, background-color 0.3s ease",

    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const combinedRef = useMemo(
    () => (node) => {
      footerRef.current = node;
      drop(node);
    },
    [drop]
  );

  return (
    <header
      ref={combinedRef}
      style={footerStyle}
      onMouseEnter={() => setIsFooterHovered(true)}
      onMouseLeave={() => setIsFooterHovered(false)}
      onFocus={() => setIsFooterFocused(true)}
      onBlur={() => setIsFooterFocused(false)}
      onMouseDown={() => setIsFooterActive(true)}
      onMouseUp={() => setIsFooterActive(false)}
      tabIndex={0}
    >
      {footer.children &&
        footer.children.map((child) => {
          switch (child.name) {
            case "Button":
              return <ButtonComponent key={child.id} button={child} />;
            case "Image":
              return <ImageComponent key={child.id} image={child} />;
            case "Heading":
              return <HeaderComponent key={child.id} header={child} />;
            case "Paragraph":
              return <ParagraphComponent key={child.id} paragraph={child} />;
            case "Icon":
              return <IconComponent key={child.id} icon={child} />;
            case "Link":
              return <LinkComponent key={child.id} link={child} />;
            case "Checkbox":
              return <CheckboxComponent key={child.id} checkbox={child} />;
            case "Radio":
              return <RadioComponent key={child.id} radio={child} />;
            case "List":
              return <ListComponent key={child.id} list={child} />;
            case "Table":
              return <TableComponent key={child.id} table={child} />;
            case "Video":
              return <VideoComponent key={child.id} video={child} />;
            case "Text":
              return <TextInputComponent key={child.id} textInput={child} />;
            case "Range":
              return <RangeComponent key={child.id} range={child} />;
            case "Password":
              return (
                <PasswordInputComponent key={child.id} passwordInput={child} />
              );
            case "Email":
              return <EmailInputComponent key={child.id} emailInput={child} />;
            case "Number":
              return (
                <NumberInputComponent key={child.id} numberInput={child} />
              );
            case "Date":
              return <DateInputComponent key={child.id} dateInput={child} />;
            case "Color":
              return <ColorInputComponent key={child.id} colorInput={child} />;
            case "File":
              return <FileInputComponent key={child.id} fileInput={child} />;
            case "Audio":
              return <AudioComponent key={child.id} audio={child} />;
            case "DropDown":
              return <DropDownComponent key={child.id} dropdown={child} />;
            case "Output":
              return <OutputComponent key={child.id} output={child} />;
            case "Map":
              return <MapComponent key={child.id} map={child} />;
            case "Nav":
              return <Nav key={child.id} nav={child} />;
            case "Header":
              return <HeaderTag key={child.id} headertag={child} />;
            case "HGroup":
              return <Hgroup key={child.id} hgroup={child} />;
            case "Footer":
              return <Footer key={child.id} footer={child} />;
            case "Section":
              return <Section key={child.id} section={child} />;
            case "Span":
              return <Span key={child.id} span={child} />;
            case "Form":
              return <FormComponent key={child.id} form={child} />;
            case "Main":
              return <MainComponent key={child.id} main={child} />;
            case "Article":
              return <ArticleComponent key={child.id} article={child} />;
            case "Aside":
              return <AsideComponent key={child.id} aside={child} />;
            case "HorizontalRule":
              return <HRTag key={child.id} div={child} />;
            case "LineBreak":
              return <BRTag key={child.id} div={child} />;
            case "Iframe":
              return <IframeComponent key={child.id} div={child} />;
            default:
              return <Division key={child.id} div={child} />;
          }
        })}
    </header>
  );
};

export default Footer;
